import { render, staticRenderFns } from "./Booking1.vue?vue&type=template&id=17727c12&scoped=true&"
import script from "./Booking1.vue?vue&type=script&lang=ts&"
export * from "./Booking1.vue?vue&type=script&lang=ts&"
import style0 from "./Booking1.vue?vue&type=style&index=0&id=17727c12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17727c12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDatePicker,VSelect})
